import { component } from "picoapp";

export const productReviews = component((node: HTMLElement) => {
  const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((addedNode) => {
          if (
            addedNode instanceof HTMLElement &&
            addedNode.querySelector(".sr-only")
          ) {
            const starRating = addedNode
              .querySelector(".sr-only")
              .textContent.split(" ")[0];
            const reviewsText = node.querySelector("a.text-m");

            if (reviewsText) {
              const reviewsCount = reviewsText.textContent;
              reviewsText.textContent = `(${starRating}) ${reviewsCount}`;
            }

            observer.disconnect();
          }
        });
      }
    }
  });

  observer.observe(node, { childList: true, subtree: true });
});
